<template>
  <div>processed</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'stripe-success',

  computed: {
    ...mapState(['user_data', 'userType']),
  },

  created() {
    console.log('stripe processed', this.$route);
  },
};
</script>

<style scoped></style>
